export const MAPPING_FIELDS = [
    { key: 'bookingDate', label: 'Buchungsdatum', required: true },
    { key: 'valueDate', label: 'Valutadatum', required: false },
    { key: 'amount', label: 'Betrag', required: true },
    { key: 'currency', label: 'Waehrung', required: false },
    { key: 'purposeText', label: 'Verwendungszweck', required: true },
    { key: 'counterpartyName', label: 'Empfaenger/Zahlungspflichtiger', required: false },
    { key: 'iban', label: 'IBAN', required: false },
    { key: 'bic', label: 'BIC', required: false },
    { key: 'category', label: 'Kategorie', required: false },
    { key: 'referenceId', label: 'Transaktions-ID/Referenz', required: false },
];

const STORAGE_PREFIX = 'bank-csv-mapping:';

export const getLineNumber = (row, index) => (Number.isFinite(row?.lineNumber) ? row.lineNumber : index + 1);

export const isRowSelectable = (row) => !(Array.isArray(row?.errors) && row.errors.length > 0);

export const formatDate = (value) => {
    if (!value) {
        return '';
    }
    try {
        return new Date(value).toLocaleDateString('de-DE');
    } catch (error) {
        return value;
    }
};

export const formatAmount = (amount, currency) => {
    if (amount == null) {
        return '';
    }
    const numeric = Number(amount);
    const code = currency || 'EUR';
    if (!Number.isFinite(numeric)) {
        return String(amount);
    }
    try {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: code }).format(numeric);
    } catch (error) {
        return String(amount);
    }
};

export const buildMappingPayload = (mapping) => ({
    bookingDate: mapping?.bookingDate ?? null,
    valueDate: mapping?.valueDate ?? null,
    amount: mapping?.amount ?? null,
    currency: mapping?.currency ?? null,
    purposeText: mapping?.purposeText ?? null,
    counterpartyName: mapping?.counterpartyName ?? null,
    iban: mapping?.iban ?? null,
    bic: mapping?.bic ?? null,
    category: mapping?.category ?? null,
    referenceId: mapping?.referenceId ?? null,
});

export const hasAnyMapping = (mapping) => Object.values(buildMappingPayload(mapping)).some((value) => Number.isFinite(value));

export const mappingEquals = (left, right) => {
    const leftPayload = buildMappingPayload(left);
    const rightPayload = buildMappingPayload(right);
    return Object.keys(leftPayload).every((key) => leftPayload[key] === rightPayload[key]);
};

const buildMappingKey = (headers = []) => {
    const signature = headers.map((header) => String(header || '').trim().toLowerCase()).join('|');
    return `${STORAGE_PREFIX}${signature}`;
};

export const loadMappingFromStorage = (headers) => {
    try {
        const key = buildMappingKey(headers);
        const stored = localStorage.getItem(key);
        if (!stored) {
            return null;
        }
        const parsed = JSON.parse(stored);
        if (!parsed || typeof parsed !== 'object') {
            return null;
        }
        const sanitized = buildMappingPayload(parsed);
        const maxIndex = headers.length - 1;
        Object.keys(sanitized).forEach((key) => {
            const value = sanitized[key];
            if (!Number.isFinite(value) || value < 0 || value > maxIndex) {
                sanitized[key] = null;
            }
        });
        return sanitized;
    } catch (error) {
        return null;
    }
};

export const persistMapping = (headers, mapping) => {
    try {
        const key = buildMappingKey(headers);
        localStorage.setItem(key, JSON.stringify(buildMappingPayload(mapping)));
    } catch (error) {
        // ignore storage errors
    }
};

export const createCsvFromRows = (rows, headers, mapping) => {
    const csvRows = [];

    const headerRow = headers.map((header) => `"${String(header).replace(/"/g, '""')}"`).join(',');
    csvRows.push(headerRow);

    rows.forEach((row) => {
        const dataRow = headers
            .map((_, index) => {
                let value = '';
                const fieldKey = Object.keys(mapping).find((key) => mapping[key] === index);
                if (fieldKey && row[fieldKey] !== undefined && row[fieldKey] !== null) {
                    value = String(row[fieldKey]);
                }

                if (value.includes(',') || value.includes('"') || value.includes('\n')) {
                    value = `"${value.replace(/"/g, '""')}"`;
                }
                return value;
            })
            .join(',');
        csvRows.push(dataRow);
    });

    return csvRows.join('\n');
};
